import { http } from 'helpers/httpv2';

const URL_V2 = process.env.REACT_APP_API_V2;
const list = 'team/management/';
const create = 'team/management/create';
const addTeamMember = 'team/management/assignment/member';

export const apiPtListTeamManagement = async ({ detail, id = 'list' }) => {
  let url = `${URL_V2 + list}list?page=1&page_size=1000`;
  if (detail) {
    url = `${URL_V2 + list + id}`;
  }
  const datas = await http.get(`${url}`);
  return datas.data.data;
};
export const apiPtAddTeamManagement = async (val) => {
  const datas = await http.post(`${URL_V2 + create}`, val);
  return datas.data.data;
};
export const apiPtAddTeamMember = async (val) => {
  const datas = await http.post(`${URL_V2 + addTeamMember}`, val);
  return datas.data.data;
};
